(function () {
  "use strict";

  function normalizePath(e) {
    if (!e) return "";
    try {
      return new URL(e, window.location.origin).pathname.replace(/\/+$/, "") || "/";
    } catch (e) {
      return "";
    }
  }

  function escapeHtml(e) {
    return String(e)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function resizeShopifyImageUrl(url, width) {
    if (!url) return "";

    try {
      var imageUrl = new URL(url, window.location.origin);

      imageUrl.searchParams.delete("width");
      imageUrl.searchParams.delete("height");
      imageUrl.searchParams.delete("crop");

      imageUrl.searchParams.set("width", width || 1600);

      return imageUrl.toString();
    } catch (e) {
      return url;
    }
  }

  function getNavItemData(e) {
    return e
      ? {
          title: e.dataset.navTitle || e.textContent.trim(),
          url: e.dataset.navUrl || e.getAttribute("href") || "",
          normalizedUrl: normalizePath(e.dataset.navUrl || e.getAttribute("href") || ""),
          type: e.dataset.navType || "",
          collectionHandle: e.dataset.navCollectionHandle || "",
          bubbleImage: e.dataset.navBubbleImage || "",
          children: []
        }
      : null;
  }

  function buildMegaMenuTreeItem(e) {
    var t = e.querySelector(":scope > a[data-nav-item]");
    if (!t) return null;

    var a = getNavItemData(t);
    var n = e.querySelectorAll(":scope > ul > li > a[data-nav-item]");

    a.children = Array.from(n).map(getNavItemData).filter(Boolean);
    return a;
  }

  function buildDropdownTreeItem(e) {
    var t = e.querySelector(':scope > details[is="dropdown-disclosure"]');

    if (t) {
      var a = t.querySelector(":scope > summary[data-nav-item]");
      if (!a) return null;

      var n = getNavItemData(a);
      var l = t.querySelectorAll(":scope > .dropdown-menu > ul > li > a[data-nav-item]");

      n.children = Array.from(l).map(getNavItemData).filter(Boolean);
      return n;
    }

    var r = e.querySelector(":scope > a[data-nav-item]");
    return r ? getNavItemData(r) : null;
  }

  function buildHeaderNavigationTree() {
    var e = document.querySelector(".header__main-nav nav.header__link-list[role='navigation'] > ul.contents");
    if (!e) return [];

    return Array.from(e.children)
      .map(function (e) {
        var t = e.querySelector(':scope > details[is="mega-menu-disclosure"]');

        if (t) {
          var a = t.querySelector(":scope > summary[data-nav-item]");
          if (!a) return null;

          var n = getNavItemData(a);
          var l = t.querySelectorAll(":scope > .mega-menu > .mega-menu__nav > li");

          n.children = Array.from(l).map(buildMegaMenuTreeItem).filter(Boolean);
          return n;
        }

        var r = e.querySelector(':scope > details[is="dropdown-disclosure"]');

        if (r) {
          var i = r.querySelector(":scope > summary[data-nav-item]");
          if (!i) return null;

          var o = getNavItemData(i);
          var c = r.querySelectorAll(":scope > .dropdown-menu > ul > li");

          o.children = Array.from(c).map(buildDropdownTreeItem).filter(Boolean);
          return o;
        }

        var s = e.querySelector(":scope > a[data-nav-item]");
        return s ? getNavItemData(s) : null;
      })
      .filter(Boolean);
  }

  function findMatchingNavigationItem(e, t, a) {
    var n = e.find(function (e) {
      return (t && e.collectionHandle === t) || (a && e.normalizedUrl === a);
    });

    return (
      n ||
      e
        .map(function (e) {
          return e.children.length > 0 ? findMatchingNavigationItem(e.children, t, a) : null;
        })
        .filter(Boolean)[0] ||
      null
    );
  }

  function buildDynamicBubbleCells(e, t, a) {
    return e
      .filter(function (e) {
        return e.collectionHandle || (e.type === "collection_link" && e.normalizedUrl);
      })
      .map(function (e) {
        var n = (t && e.collectionHandle === t) || (a && e.normalizedUrl === a);
        var imageUrl = resizeShopifyImageUrl(e.bubbleImage, 1600);

        var l = e.bubbleImage
          ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(e.title) + '" loading="lazy">'
          : '<div class="bubble-fallback"></div>';

        return (
          '<a href="' +
          escapeHtml(e.url) +
          '" class="carousel-cell' +
          (n ? " active-collection" : "") +
          '">' +
          '<div class="bubble-media-wrapper">' +
          l +
          "</div>" +
          '<div class="bubble-heading">' +
          escapeHtml(e.title) +
          "</div>" +
          "</a>"
        );
      })
      .join("");
  }

  function getDynamicBubbleCells(e) {
    var t = e.dataset.currentCollectionHandle || "";
    var a = normalizePath(e.dataset.currentCollectionUrl || window.location.pathname);

    if (!t && !a) return "";

    var n = findMatchingNavigationItem(buildHeaderNavigationTree(), t, a);

    return n && n.children.length !== 0 ? buildDynamicBubbleCells(n.children, t, a) : "";
  }

  function renderBubbleCells(e, t, a) {
    if (e) e.innerHTML = a;

    if (t) {
      t.innerHTML = a;
    }
  }

  function getActiveIndex(e) {
    var t = Array.from(e.querySelectorAll(".carousel-cell")).findIndex(function (e) {
      return e.classList.contains("active-collection");
    });

    return t > -1 ? t : 0;
  }

  function getFlickityOptions(e) {
    return {
      groupCells: false,
      pageDots: false,
      draggable: true,
      cellAlign: "left",
      prevNextButtons: false,
      wrapAround: false,
      contain: false,
      imagesLoaded: true,
      adaptiveHeight: false,
      freeScroll: false,
      selectedAttraction: 0.025,
      friction: 0.28,
      initialIndex: e || 0
    };
  }

  function refreshFlickity(e) {
    if (!e) return;

    e.resize();
    e.reposition();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".bubbles-section").forEach(function (section) {
      var desktopSlider = section.querySelector(".desktop-flickity");
      var mobileSlider = section.querySelector(".mobile-flickity");

      if (!desktopSlider || !mobileSlider) return;

      var staticCells = (desktopSlider.getAttribute("data-bubble-cells") || "").trim();
      var dynamicCells = getDynamicBubbleCells(section);
      var cells = staticCells || dynamicCells;

      if (!cells) {
        section.hidden = true;
        return;
      }

      section.hidden = false;
      renderBubbleCells(desktopSlider, mobileSlider, cells);

      var desktopFlkty = null;
      var mobileFlkty = null;

      function initDesktop() {
        if (desktopFlkty) {
          desktopFlkty.destroy();
          desktopFlkty = null;
        }

        var activeIndex = getActiveIndex(desktopSlider);

        desktopFlkty = new Flickity(desktopSlider, getFlickityOptions(activeIndex));

        desktopFlkty.on("ready", function () {
          refreshFlickity(desktopFlkty);
        });

        desktopFlkty.on("settle", function () {
          refreshFlickity(desktopFlkty);
        });

        setTimeout(function () {
          refreshFlickity(desktopFlkty);
        }, 250);

        setTimeout(function () {
          refreshFlickity(desktopFlkty);
        }, 800);
      }

      function initMobile() {
        if (mobileFlkty) {
          mobileFlkty.destroy();
          mobileFlkty = null;
        }

        var activeIndex = getActiveIndex(mobileSlider);

        mobileFlkty = new Flickity(mobileSlider, getFlickityOptions(activeIndex));

        mobileFlkty.on("ready", function () {
          refreshFlickity(mobileFlkty);
        });

        mobileFlkty.on("settle", function () {
          refreshFlickity(mobileFlkty);
        });

        setTimeout(function () {
          refreshFlickity(mobileFlkty);
        }, 250);

        setTimeout(function () {
          refreshFlickity(mobileFlkty);
        }, 800);
      }

      function updateMode() {
        if (window.innerWidth >= 750) {
          desktopSlider.style.display = "block";
          mobileSlider.style.display = "none";

          if (!desktopFlkty) initDesktop();

          if (mobileFlkty) {
            mobileFlkty.destroy();
            mobileFlkty = null;
          }

          refreshFlickity(desktopFlkty);
        } else {
          desktopSlider.style.display = "none";
          mobileSlider.style.display = "block";

          if (!mobileFlkty) initMobile();

          if (desktopFlkty) {
            desktopFlkty.destroy();
            desktopFlkty = null;
          }

          refreshFlickity(mobileFlkty);
        }
      }

      updateMode();

      var resizeTimer;

      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function () {
          updateMode();
        }, 150);
      });
    });
  });
})();